import styled from 'styled-components'

export const Wrapper = styled.div(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
}))
